import React, {FC} from 'react';
import StringToDomParser from 'components/ContentPagesComponents/_StringToDomParser';
import {PageHead} from 'components/PageHead';
import Wrapper, {PageStyle} from 'components/Wrapper';
import {graphql} from 'gatsby';
import {ProductLdJson} from 'pages/pricing';

export const query = graphql`
query ($path: String, $title: String, $env: String) {
	content: airtable(data: {
		Path: {eq: $path}
		Title: {eq: $title}
		Environments: {in: [$env]}
	}) {
		data {
			tags: Tags {
				data {
					name: Name
					property: Property
					content: Content
				}
			}
			tagSets: Tag_Sets {
				data {
					tags: Tags {
						data {
							name: Name
							property: Property
							content: Content
						}
					}
				}
			}
			canonical: Canonical
			xml: XML
		}
	}
}`;

export type Meta = {
	name: string
	property: string
	content: string
}

export type Tag = {
	data: Meta
}

export type TagSet = {
	data: {
		tags?: Tag[]
	}
}

interface ContentPageProps {
	pageContext: {
		title: string
	}
	data: {
		content: {
			data: {
				tags?: Tag[]
				tagSets?: TagSet[]
				canonical: string
				xml: string
			}
		}
	}
}

const ContentPage: FC<ContentPageProps> = ({data}) => {
	return (
		<Wrapper style={PageStyle.ContentPage}>
			<StringToDomParser xml={data.content.data.xml} />
		</Wrapper>
	);
};

export default ContentPage;

type TagsData = {
	tags?: Tag[]
	tagSets?: TagSet[]
}

export const parseTags = (data: TagsData): Meta[] => {
	const {tags, tagSets} = data;
	const uniq: Record<string, Meta> = {};

	// Add each tagset tag to our output
	(tagSets || []).forEach((set) => {
		(set.data.tags || []).forEach((tag) => {
			uniq[tag.data.property] = tag.data;
		});
	});

	// Add each explict tag to our output; overwriting existing
	(tags || []).forEach((tag) => {
		uniq[tag.data.property] = tag.data;
	});

	// Return the unique combined set of all tags
	return Object.values(uniq);
};

export const Head = PageHead<ContentPageProps>(
	({data, pageContext}) => {

		// Check if keywords is a tagged for this page
		const hasKeywords = Boolean(
			data.content.data.tags?.
				find(x => x.data.name === 'keywords')
		);

		return {
			title: pageContext.title,
			meta: parseTags(data.content.data),
			canonical: data.content.data.canonical,
			custom: hasKeywords ? ProductLdJson: undefined,
		};
	}
);
